import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import { languageMap } from "../helpers/language";
import { isArray } from "lodash";

class RecognizerManager {

  constructor() {
    this.recognizer = null;
    this.speechConfig = null;
    this.sessionId = null;
  }

  async initializeSpeechService(token, selectedLanguage, region) {

    this.speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(token, region);

    if (selectedLanguage?.code === "es") {
      this.speechConfig.speechRecognitionLanguage = "es-PR";
    }

    this.speechConfig.setProperty(SpeechSDK.PropertyId.Conversation_Initial_Silence_Timeout, "0");
    this.speechConfig.setProperty(SpeechSDK.PropertyId.Speech_SegmentationSilenceTimeoutMs, "500");

    await this.initializeSpeechLanguage(selectedLanguage?.code);
  }

  async initializeSpeechLanguage(language) {
    if (this.recognizer) {
      this.recognizer.close();
      this.recognizer = null;
    }

    const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();

    if(isArray(languageMap?.[language])){
      const languages = languageMap?.[language]?.join(',');
      this.speechConfig.setProperty(SpeechSDK.PropertyId.SpeechServiceConnection_LanguageIdMode, "Continuous");
      this.speechConfig.setProperty(SpeechSDK.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, languages);
    } else {
      this.speechConfig.speechRecognitionLanguage = languageMap?.[language] || "en-US";
    }

    // if (language === "en-es") {
    //  this.speechConfig.setProperty(SpeechSDK.PropertyId.SpeechServiceConnection_LanguageIdMode, "Continuous");
    //  this.speechConfig.setProperty(SpeechSDK.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, "en-US,es-PR");
    // } else {
    //   this.speechConfig.speechRecognitionLanguage = languageMap?.[language] || "en-US";
    // }

    await this.createRecognizer(this.speechConfig, audioConfig);
  }

  async createRecognizer(speechConfig, audioConfig) {
    this.recognizer = new SpeechSDK.ConversationTranscriber(speechConfig, audioConfig);
  }

  async startTranscription(handleTranscribing, handleTranscribed) {
    if (!this.recognizer) {
      console.error("Recognizer not initialized");
      return;
    }

    this.recognizer.transcribing = (s, e) => {
      handleTranscribing(e);
    };

    this.recognizer.transcribed = (s, e) => {
      // console.log("initializeSttTokenService: transcribed", this.recognizer.authorizationToken, this.speechConfig.authorizationToken)
      handleTranscribed(e);
    };

    this.recognizer.canceled = (s, e) => {
      console.error(`CANCELED: Reason=${e.reason}, ErrorCode=${e.errorCode}, ErrorDetails=${e.errorDetails}`);
    };

    this.recognizer.sessionStarted = (s, e) => {
      this.sessionId = e.sessionId;
    };

    if (this.sessionId) {
      const conn = SpeechSDK.Connection.fromRecognizer(this.recognizer);
      conn.setMessageProperty("speech.context", "phraseDetection", {
        mode: "Conversation",
        speakerDiarization: {
          mode: "Anonymous",
          audioSessionId: this.sessionId,
        },
      });
    }

    this.recognizer.startTranscribingAsync(
      () => console.log("Transcription started successfully."),
      (err) => console.error("Failed to start transcription:", err)
    );
  }

  stopTranscription() {
    if (this.recognizer) {
      this.recognizer.stopTranscribingAsync(
        () => {
          console.log("Transcription stopped.")
        },
        (err) => console.error("Failed to stop transcription:", err)
      );
    }
  }

  pauseTranscription() {
    if (this.recognizer) {
      this.recognizer.stopTranscribingAsync(() => {
        console.log("Transcription paused.");
      }, (err) => console.error("Failed to pause transcription:", err));
    }
  }

  resumeTranscription() {
    if (this.recognizer) {
      this.recognizer.startTranscribingAsync(() => {
        console.log("Transcription resumed.");
      }, (err) => console.error("Failed to resume transcription:", err));
    }
  }
}

export const recognizerManager = new RecognizerManager();
